let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9NysB")).then(() => parcelRequire('8jWFf'));